/**
 * Resolve a content-service locale (e.g. "de-DE") to one of our registered i18n
 * locale codes (e.g. "de").
 *
 * The content service sends BCP-47 region tags ("de-DE", "fr-FR", ...), but i18n is
 * configured with base codes ("de", "fr") plus a few explicit region variants
 * ("de-CH"). Passing an unregistered tag like "de-DE" to `t(key, n, { locale })` makes
 * vue-i18n rely on its implicit region->base fallback, which is non-deterministic on a
 * cold SSR request (the key can briefly resolve via `fallbackLocale` to English before
 * messages settle). Resolving to a registered code up front removes that dependency.
 *
 * Resolution order: exact match -> base-language match -> fallback.
 */
export function resolveI18nLocale(raw: string | undefined | null, availableCodes: string[], fallback: string): string {
  if (!raw)
    return fallback

  if (availableCodes.includes(raw))
    return raw

  const base = raw.split("-")[0]
  if (availableCodes.includes(base))
    return base

  return fallback
}
